import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import React from "react";
import { useFragment } from "react-relay";

import { Avatar } from "@whoosh/design-system/src/components/display";
import { Text, HStack } from "@whoosh/design-system/src/components/primitive";

import { EventDetailAttendeesListItemFragment$key } from "./__generated__/EventDetailAttendeesListItemFragment.graphql";

type EventDetailAttendeesListItemtProps = {
  fragmentRef: EventDetailAttendeesListItemFragment$key | null;
  playerNounOverride?: string;
};

export const EventDetailAttendeesListItem = ({
  fragmentRef,
  playerNounOverride,
}: EventDetailAttendeesListItemtProps) => {
  const data = useFragment(
    EventDetailAttendeesListItemFragmentString,
    fragmentRef
  );

  const registration = data?.registrations?.edges?.[0]?.node?.registrant;

  const name =
    registration?.firstName && registration?.lastName
      ? `${registration?.firstName} ${registration?.lastName}`
      : t`Unknown ${playerNounOverride ?? "Player"}`;

  return (
    <HStack alignItems="center" py={1} gap={4}>
      <Avatar
        size="sm"
        profileImagePublicId={registration?.profileImage?.publicId}
        firstName={registration?.firstName}
        lastName={registration?.lastName}
        type="member"
      />

      <Text maxFontSizeMultiplier={2} variant="mainBaseMedium">
        {name}
      </Text>
    </HStack>
  );
};

export const EventDetailAttendeesListItemFragmentString = graphql`
  fragment EventDetailAttendeesListItemFragment on EventSignUp {
    waitlistIndex
    id
    checkedIn
    registrations {
      edges {
        node {
          id
          type
          index
          registrant {
            id
            firstName
            lastName
            profileImage {
              # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
              publicId: renderingKey
            }
          }
          formResponses {
            edges {
              node {
                id
                booleanValue
                stringValue
                transportationType {
                  id
                }
                questionConfiguration {
                  enabled
                  id
                  type
                }
              }
            }
          }
        }
      }
    }
  }
`;
